import styled from "styled-components";
import { spacing } from "@styling/sizing";

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${spacing.x2}px;
  gap: ${spacing.x2}px;
  display: flex;
  flex-direction: column;
  margin-bottom: 100px;
  
  @media (max-width: 768px) {
    padding: ${spacing.x1}px;
    gap: ${spacing.x1}px;
  }
`;

